export const team = [
    //{
    //   slug: '',
    // name: '',
    //title: '',
    //image: ''
    //},

    {
        slug: 'lola-oshiafi',
        name: 'Lola Oshiafi',
        title: 'GMD',
        image: 'lola',
        details: [
            'BOARD VALUE PROPOSITION',
            'Strategic leader with 20+ years of cross-sector experience spanning law, banking, coaching, and counselling. Combines legal, financial, and human capital expertise to drive organizational performance, stakeholder engagement, and governance excellence. Skilled in leadership development, relationship management, and organizational transformation. Brings a unique blend of corporate discipline and emotional intelligence to board decision-making.',
        ]
    },
    // {
    //     slug: 'dr-femi-lalude',
    //     name: 'Dr. Femi Lalude',
    //     title: 'Director',
    //     image: 'teamperson',
    //     details: [
    //         'He retired as Director and General Manager for Shell Nigeria Exploration Production Company, SNEPCO a Shell in deep offshore and fair inland oil and gas exploration.',
    //         'He was one-time General Manager of Shell\'s Western Division in Warri, and prior to that the Engineering Manager for Shell Nigeria.',
    //         'He also had international exposure with Shell in Holland and USA in earlier years. He was a Senior Designer (Mechanical) Engineer for Nuclear Power plants at Bechtel Corporation of US.',
    //         'He is currently an oil/gas industry consultant and sits on the Board of various companies servicing Oil and Gas sector.'
    //     ]
    // },
    
    {
        slug: 'TAIYE ALUKO',
        name: 'TAIYE ALUKO',
        title: 'Director',
        image: 'taiye',
        details: [
            'B.Sc. (Hons.) in Banking & Finance. Chartered Banker (ACIB) with over 22 years of banking experience.',
            'Vice-President at First City Merchant Bank Limited.',
            'Currently the Managing Consultant of Edward Consulting School of Banking.'
        ]
    },
    {
        slug: 'dr-larry-osa-afiana',
        name: 'Dr. Larry O. Osa-Afiana',
        title: 'Director',
        image: 'larry',
        details: [
            'Dr. Larry Osa-Afiana has over 25 years of experience in merchant, commercial, and development banking, with expertise in corporate banking and credit risk management.',
            'He held leadership roles at the Bank of America, Citibank N.A, and was the pioneer Managing Director/CEO of Citizens International Bank and Bank of Industry.',
            'A seasoned consultant and academic, he specializes in finance, agriculture, and industrial development, serving as an independent consultant and adjunct faculty at Lagos Business School.',
            'Dr. Osa-Afiana holds a B.Sc. in Agriculture (First Class) from Ahmadu Bello University and advanced degrees (M.Sc and Ph.D) in Soil Science from Cornell University, USA.'
        ]
    },

    {
        slug: 'dr-deborah-elue',
        name: 'Dr. Deborah Elue',
        title: 'Director',
        image: 'deborah',
        details: [
            'Deborah is a seasoned finance professional with over 20 years of experience in assurance, tax, and advisory services.',
            'As an Associate Director at Ernst & Young Nigeria, she led engagements across diverse sectors, including oil and gas, managing audits for global companies such as Seplat Energy, Mobil Oil, and Saipem.',
            'A fellow of ICAN with a B.Sc. in Accounting from the University of Benin, she has extensive expertise in audit strategy, IFRS compliance, financial investigations, and due diligence.',
            'Deborah has attended international training, including the Senior Managers Program in Copenhagen, and gained global experience during her secondment to EY South Africa.'
        ]
    },

    {
        slug: 'mohammed-edewor',
        name: 'Mohammed Edewor',
        title: 'Director',
        image: 'mohammed',
        details: [
            'Mohammed is a seasoned legal practitioner with over 20 years of experience in oil and gas, real estate, telecoms, marine amongst others.',
            'Mohammed graduated from the University of Buckingham, UK. He is the principal partner of Edewor and company.',
            'He is executive chairman, Aquafront Limited. Director, Multigrated Resources Nigeria Limited. Chairman, Alfacrest realtors. Chairman, Flamingo airlines limited(charter only). Chairman, Sky brewery limited.',
        ]
    },
    
    // {
    //     slug: 'yahaya-yunusa',
    //     name: 'Yahaya Yunusa',
    //     title: 'Director',
    //     image: 'yahaya',
    //     details: [
    //         'Yahaya has over 23 years’ experience in the mid and downstream oil and gas sector, and has consistently driven growth, operational efficiency, and innovation in various executive capacities.',
    //         'Up-till April 2025, Yahaya was engaged as a (Management Consultant and C.E.O) at AP Oil & Gas Ghana ltd. Within the past one year (2024), Yahaya directly led and coached the AP Oil and Gas team to relaunch the company that had been dormant, into full operations, with a new look, in the Retail and B2B sectors of the Ghana downstream Market.',
    //         'Prior to this, Yahaya spent a period of 3 years in the Telecoms Industry where he served as CEO at American Tower Corporation, Ghana, where he led the charge in the provision of telecoms infrastructure and energy solutions to mobile network operators. Yahaya led the successful Change Management and the Post-Merger consolidation of Eaton Towers and American Tower Corporation in Ghana. The company grew to achieve a significant annual EBITDA growth of ~$100 million in 2021, reaffirming its industry leadership. Yahaya was awarded the Ghana Telecoms Tower CEO of the year 2022 by the Ghana Information Technology & Telecom Awards (GITTA)',
    //         'Yahaya’s noteworthy efforts and ground breaking achievements have significantly contributed to the profitability of various businesses and market share expansions within his career in Nigeria and Internationally. This has earned Yahaya various recognitions and the reputation of a seasoned and transformational executive leader in the Oil and Gas Industry.'
    //     ]
    // }
]



export const services = [
    {
        heading: 'AVIATION SECTOR',
        slug: 'aviation-sector',
        icon: 'aviation',
        image: 'aviationsector',
        details: `
        <p>
             Aviation insurance is a sensitive insurance sector which includes so many insurance products such as: Aircraft Hull Insurance, Airport Owners’ and Operators’ Liability Insurance, Passenger Liability Insurance, Airport Owners’ and Operators’ Liability Insurance, Hangar Keeper’s Liability, Aviation Product Liability Insurance.
        </p>
        `
    },
    {
        icon: 'construction',
        heading: 'CONSTRUCTION SECTOR',
        slug: 'construction-sector',
        image: 'constructionsector',
        details: `
        <p>
            CONSTRUCTION/ALL RISK (C.A.R) insurance policy is a type of property and liability insurance designed for construction projects. It protects against physical loss or damage to contract works, materials, and equipment on the project site, as well as the legal liability of the insured for third-party bodily injury or property damage. This comprehensive policy is typically taken out by contractors and project owners to cover various construction and civil engineering projects. 
        </p>
        `
    },
    {
        icon: 'healthcare',
        heading: 'HEALTHCARE SECTOR',
        slug: 'healthcare-pharmaceutical-sector',
        image: 'healthcaresector',
        details: `
        <p>
            Health Insurance is an agreement where a company pays for some or all of a person's medical expenses in exchange for a regular premium payment. It provides financial protection against high medical costs for things like doctor visits, hospital stays, medications, and surgeries. Health insurance helps manage both routine and emergency healthcare costs, making treatment more accessible and financially predictable for the policyholder. 
        </p>
        `
    },
    {
        icon: 'gas',
        heading: 'OIL AND GAS',
        slug: 'oil-and-gas',
        image: 'oil&gassector',
        details: `
        <p>
        This policy covers all risks of physical loss and destruction to the insured properties, including legal liability arising from damage to the insured's properties or resulting from the insured's operations, which may involve their agents.

        </p>
        `
    },
    {
        icon: 'manufacturing',
        heading: 'MANUFACTURING SECTOR',
        slug: 'manufacturing-sector',
        image: 'manufacturingsector',
        details: `
        <p>
            Manufacturing Insurance is specifically designed to protect businesses involved in the manufacturing industry. It provides coverage for a wide range of risks and liabilities that are unique to the manufacturing sector. It provides coverage for a wide range of risks and liabilities that are unique to the manufacturing sector.
        </p>
        `
    },
    {
        icon: 'agriculture',
        heading: 'AGRICULTURAL SECTOR',
        slug: 'agricultural-sector',
        image: 'agriculturalsector',
        details: `
        <p>
         Agricultural Insurance is a policy that protects farmers against financial loss from crop and livestock damage due to specific perils like fire, flood, drought, or pests. Farmers pay a premium to an insurer, which promises to indemnify them by paying the value of the loss if a covered event occurs. This can cover a wide range of assets including crops, livestock, farm equipment, and produce
        </p>
        `
    },
    {
        icon: 'transportation',
        heading: 'TRANSPORTATION SECTOR',
        slug: 'transportation',
        image: 'transportsector',
        details: `
        <p>
            Transport Insurance is insurance whereby an insurance company undertakes to pay certain indemnities as a result of damage occurring during the transport of goods. This damage can affect the transporting object (hull insurance) or the transported goods themselves (goods insurance).
        </p>
        <br/>
        <h3>There are three main types of policy.</h3>
        <br/>
        <ul>
        <li>• Third party. This is the minimum legal requirement and covers you for damage to someone else's vehicle or property or injury to someone else in an accident.</li>
        <li>• Third party, fire and theft.</li>
        <li>• Comprehensive cover.</li>
        </ul>
        `
    },
    {
        icon: 'money',
        heading: 'FINANCE SECTOR',
        slug: 'finance-sector',
        image: 'transportsector',
        details: `
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eum perspiciatis in assumenda reiciendis, placeat quod quasi magni amet provident voluptate fuga hic possimus! Quasi nisi perferendis dicta dolore commodi, molestias velit animi dignissimos dolorem. Debitis voluptate, reiciendis aspernatur dicta recusandae minus, nam ab, mollitia doloribus laboriosam facere magnam ex non. Provident vitae velit, adipisci enim omnis deleniti facilis itaque pariatur!
        </p>
        <br/>
        <h3>There are three main types of policy.</h3>
        <br/>
        <ul>
        <li>• Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eum perspiciatis in assumenda reiciendis, placeat quod quasi magni amet</li>
        <li>•  provident voluptate fuga hic possimus! Quasi nisi perferendis dicta dolore commodi, molestias velit animi dignissimos dolorem.</li>
        <li>•  Debitis voluptate, reiciendis aspernatur dicta recusandae minus, nam ab, mollitia doloribus laboriosam facere magnam ex non. Provident vitae velit, adipisci enim omnis deleniti facilis itaque pariatur!</li>
        </ul>
        `
    },
]

export const products = [
    {
        icon: 'life',
        heading: 'Life Insurance',
        text: 'Life insurance provides financial security for loved ones in the event of the policyholder’s death. It ensures dependents are protected from financial hardships and can also serve as a savings or investment tool.',
    },
    {
        icon: 'health',
        heading: 'Health Insurance',
        text: 'Covers medical expenses, including hospitalization, medications, and preventive care, ensuring individuals and families can access quality healthcare without financial strain.',
    },
    {
        icon: 'car',
        heading: 'Motor Insurance',
        text: 'Third-Party Liability Insurance covers damages or injuries caused to a third party by the policyholder’s vehicle (mandatory in most countries), while Comprehensive Insurance provides broader coverage, including damages to the insured vehicle and third-party liabilities.',
    },
    {
        icon: 'property',
        heading: 'Property Insurance',
        text: 'Protects homes, offices, and other properties against risks like fire, theft, and natural disasters, ensuring peace of mind for property owners.',
    },
    {
        icon: 'travel',
        heading: 'Travel Insurance',
        text: 'Provides coverage for travel-related risks, such as trip cancellations, lost luggage, or medical emergencies while traveling.',
    },
    {
        icon: 'marine',
        heading: 'Marine Insurance',
        text: 'Secures goods, ships, and cargo against losses or damages during transit by sea, ensuring businesses involved in trade are protected.',
    },
    {
        icon: 'fireinsurance',
        heading: 'Fire Insurance',
        text: 'Covers property damages caused by fire, explosions, or lightning, safeguarding individuals and businesses from significant financial loss.',
    },
    {
        icon: 'liability',
        heading: 'Liability Insurance',
        text: 'Protects against legal liabilities arising from accidental harm or negligence, offering coverage for compensation claims.',
    },
    {
        icon: 'crop',
        heading: 'Crop Insurance',
        text: 'Designed for farmers, this policy protects against losses caused by natural calamities, pests, or diseases affecting crops.',
    },
    {
        icon: 'home',
        heading: 'Home Insurance',
        text: 'Provides financial protection for homes and belongings against risks like fire, theft, or natural disasters.',
    },
]

export const accordion = [
    {
        heading: 'What types of insurance do you offer?',
        text: 'tempus eu. Integer placerat mi sem, vel imperdiet nunc bibendu m eget. Nunc luctus quam vitae facilisis.'
    },
    {
        heading: 'How do I choose the right policy?',
        text: 'We help you choose the right policy by assessing your needs, budget, and circumstances. Our experts provide personalized recommendations based on thorough analysis.'
    },
    {
        heading: 'What happens if I miss a premium payment?',
        text: 'Missing a premium payment may result in a grace period. Contact us immediately to discuss payment options and maintain your coverage without interruption.'
    },
    {
        heading: 'How does the claims process work?',
        text: 'Our claims process is straightforward. Report the incident, submit required documentation, and our dedicated team will guide you through each step to ensure quick resolution.'
    },
]

export const navData = [
    {
        text: "About Us",
        desc: "We provide tailored insurance solutions for individuals, businesses, and organizations, ensuring comprehensive coverage and peace of mind. ",
        items: [
            {
                heading: "ABOUT",
                subItems: [
                    {
                        path: "/about",
                        text: "About Us",
                    },
                    {
                        path: "/about#mission-vision",
                        text: "Our Vision",
                    },
                    {
                        path: "/about#team",
                        text: "Team",
                    },
                    {
                        path: "/about#our-portfolio",
                        text: "Our Portfolio",
                    },
                ],
            },
        ],
    },
    {
        text: "Services",
        desc:
            "Established in 1994, we have always put our customers first, knowing that customers satisfaction is our ultimate goal.",
        items: [
            {
                heading: "GENERAL BUSINESS INSURANCE",
                subItems: [
                    {
                        path: "/services/general-business-insurance",
                        text: "Individual Insurance",
                    },
                    {
                        path: "/services/general-business-insurance",
                        text: "Corporate Insurance",
                    }
                ],
            },
            {
                heading: "LIFE BUSINESS INSURANCE",
                subItems: [
                    {
                        path: "/services/life-business-insurance",
                        text: "Group Life Insurance",
                    },
                    {
                        path: "/services/life-business-insurance",
                        text: "Individual life Insurance",
                    },
                    {
                        path: "/services/life-business-insurance",
                        text: "Group Personal Accident Insurance",
                    },
                ],
            },
            {
                heading: "HEALTH INSURANCE",
                subItems: [
                    {
                        path: "/services/health-insurance",
                        text: "Private Individuals",
                    },
                    {
                        path: "/services/health-insurance",
                        text: "Corporate Employees",
                    },
                ],
            },
            {
                heading: "CLAIMS MANAGEMENT",
                subItems: [
                    {
                        path: "/services/claims-management",
                        text: "Cooperate Insurance",
                    },
                    {
                        path: "/services/claims-management",
                        text: "Individual Insurance",
                    },
                ],
            },
            {
                heading: "INSURANCE INDUSTRY/SECTORS AND THEIR PRODUCT",
                subItems: [
                    {
                        path: "/services/insurance-industry",
                        text: "Aviation Sector",
                    },
                    {
                        path: "/services/insurance-industry",
                        text: "Construction Sector",
                    },
                    {
                        path: "/services/insurance-industry",
                        text: "Healthcare/Pharmaceutical Sector",
                    },
                    {
                        path: "/services/insurance-industry",
                        text: "Oil and Gas",
                    },
                    {
                        path: "/services/insurance-industry",
                        text: "Manufacturing Sector",
                    },
                    {
                        path: "/services/insurance-industry",
                        text: "Agricultural Sector",
                    },
                    {
                        path: "/services/insurance-industry",
                        text: "Transportation Sector",
                    },
                ],
            },
        ],
    },
    {
        text: "Career",
        desc:
            "We're always looking for passionate, motivated individuals who want to make a difference in people's lives.",
        items: [
            {
                heading: "GROW WITH TRUEBOND",
                subItems: [
                    {
                        path: "/career",
                        text: "Company Values and Culture",
                    },
                    {
                        path: "/career",
                        text: "Open positions",
                    },

                ],
            },
        ],
    },
    {
        text: "Claims",
        desc:
            "We're always looking for passionate, motivated individuals who want to make a difference in people's lives.",
        items: [
            {
                heading: "FILE YOUR CLAIMS",
                subItems: [
                    {
                        path: "/claims",
                        text: "How to File",
                    },
                    {
                        path: "/claims",
                        text: "Documents Required",
                    },

                ],
            },
        ],
    },
    // {
    //     text: "Media",
    //     desc:
    //         "Stay informed with the latest updates and insights",
    //     items: [
    //         {
    //             heading: "STAY INFORMED",
    //             subItems: [
    //                 {
    //                     path: "/media",
    //                     text: "News Insights",
    //                 },
    //                 {
    //                     path: "/media",
    //                     text: "Media",
    //                 },
    //             ],
    //         },

    //     ],
    // },
    {
        text: "Contact",
        desc:
            "Get in touch with Truebond Insurance Brokerage Limited for any inquiries, consultations, or support. We’re here to assist you with all your insurance needs.",
        items: [
            {
                heading: "CONTACT US",
                subItems: [
                    {
                        path: "/contact",
                        text: "Business Details",
                    },
                    {
                        path: "/contact",
                        text: "Location",
                    },
                    {
                        path: "/contact",
                        text: "Reach Out",
                    },
                ],
            },

        ],
    },
];

